/**
 * Extracts text content from HTML <li> tags and cleans up HTML entities
 * @param htmlString HTML string containing <li> elements
 * @returns Array of cleaned text strings from each <li> element
 */
export const extractListItems = (htmlString: string): string[] => {
  if (!htmlString) return [];

  const items: string[] = [];
  const liRegex = /<li>(.*?)<\/li>/g;
  let match;

  while ((match = liRegex.exec(htmlString)) !== null) {
    let cleanText = match[1];
    let previousText;
    do {
      previousText = cleanText;
      cleanText = cleanText.replace(/&nbsp;/g, ' ').replace(/<[^>]*>/g, '');
    } while (cleanText !== previousText);
    cleanText = cleanText.trim();

    if (cleanText) {
      items.push(cleanText);
    }
  }

  return items;
};

export default extractListItems;
